import { gql } from 'graphql-tag';
import {
  useMutation,
  MutationTuple,
  MutationHookOptions,
} from '@apollo/client';
import {
  RegisterGuestWithoutHcpFromArrivalDisplayWithCustomVisitTypeMutation,
  RegisterGuestWithoutHcpFromArrivalDisplayWithCustomVisitTypeMutationVariables,
} from './__generated__/useRegisterWithoutHcpMutation.generated';

const REGISTER_WITHOUT_HCP_MUTATION = gql`
  mutation RegisterGuestWithoutHCPFromArrivalDisplayWithCustomVisitType(
    $guestName: String!
    $guestEmail: String!
    $startTime: ISODateTime!
    $arrivalLocationId: ID!
    $hostUserId: ID!
    $visitType: String!
    $visitId: ID!
    $visitInviteId: ID!
  ) {
    registerGuestWithoutHCPFromArrivalDisplayWithCustomVisitType(
      guestName: $guestName
      guestEmail: $guestEmail
      startTime: $startTime
      arrivalLocationId: $arrivalLocationId
      hostUserId: $hostUserId
      visitType: $visitType
      visitId: $visitId
      visitInviteId: $visitInviteId
    )
  }
`;

/**
 * Registers a guest (creates a visit) for buildings without health checkpoints.
 *
 * This should be used only in buildings where HCPs are NOT enabled.
 * If HCPs are enabled for the building, use useRegisterWithHcpMutation instead.
 *
 * A successful response means a visit has been created.
 */
export const useRegisterWithoutHcpMutation = (
  options?: MutationHookOptions<
    RegisterGuestWithoutHcpFromArrivalDisplayWithCustomVisitTypeMutation,
    RegisterGuestWithoutHcpFromArrivalDisplayWithCustomVisitTypeMutationVariables
  >
): MutationTuple<
  RegisterGuestWithoutHcpFromArrivalDisplayWithCustomVisitTypeMutation,
  RegisterGuestWithoutHcpFromArrivalDisplayWithCustomVisitTypeMutationVariables
> => {
  return useMutation<
    RegisterGuestWithoutHcpFromArrivalDisplayWithCustomVisitTypeMutation,
    RegisterGuestWithoutHcpFromArrivalDisplayWithCustomVisitTypeMutationVariables
  >(REGISTER_WITHOUT_HCP_MUTATION, options);
};
